/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { JobOccurrenceCatalogDto } from './JobOccurrenceCatalogDto';
import {
    JobOccurrenceCatalogDtoFromJSON,
    JobOccurrenceCatalogDtoFromJSONTyped,
    JobOccurrenceCatalogDtoToJSON,
} from './JobOccurrenceCatalogDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfJobOccurrenceCatalogDto
 */
export interface ODataPostProcessedResultsOfJobOccurrenceCatalogDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceCatalogDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<JobOccurrenceCatalogDto>}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceCatalogDto
     */
    value?: Array<JobOccurrenceCatalogDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceCatalogDto
     */
    $type?: ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceCatalogDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceCatalogDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceCatalogDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum = typeof ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfJobOccurrenceCatalogDto interface.
 */
export function instanceOfODataPostProcessedResultsOfJobOccurrenceCatalogDto(value?: unknown): value is ODataPostProcessedResultsOfJobOccurrenceCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfJobOccurrenceCatalogDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfJobOccurrenceCatalogDtoFromJSON(json: any): ODataPostProcessedResultsOfJobOccurrenceCatalogDto {
    return ODataPostProcessedResultsOfJobOccurrenceCatalogDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfJobOccurrenceCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfJobOccurrenceCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(JobOccurrenceCatalogDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfJobOccurrenceCatalogDtoToJSON(value?: ODataPostProcessedResultsOfJobOccurrenceCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(JobOccurrenceCatalogDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

